import { Button, ModalsContext, Sidebar as UiKitSidebar } from '@ws/shared/components';
import { AlignLess24, AngleLeft16, Info20 } from '@ws/shared/icons';
import { useContext, useMemo } from 'react';
// eslint-disable-next-line import/no-named-as-default
import { useDispatch, useSelector } from 'react-redux';

import { AuthContainer } from '../../../components';
import { TextatorLogo } from '../../../components/TextatorLogo';
import { useSidebar } from '../../../hooks';
import { TAppState } from '../../../redux';
import { appendContentWindow } from '../../../redux/contentWindows';
import { setSelectedSecondaryNode } from '../../../redux/editor';
import { getEntityRef } from '../../../utils/getEntityRef';

import { useLeaveProject } from '../useLeaveProject';

import { getInfoModal } from './InfoModal';
import styles from './Sidebar.module.css';
import { SyncButton } from './Sync';
import { Tree } from './Tree';

export function Sidebar() {
  const { setModal } = useContext(ModalsContext);
  const dispatch = useDispatch();
  const {
    editor: { project },
  } = useSelector((store: TAppState) => store);
  const { isOpen, variant, onOpen, onClose, mobileWidth, toggleSidebar } = useSidebar();

  const handleBackButtonClick = useLeaveProject();

  function handleSplitModeTry() {
    if (!project) {
      return;
    }

    const firstNote = Object.entries(project?.notes ?? {})[0];
    if (!firstNote) {
      return;
    }

    dispatch(setSelectedSecondaryNode({ secondarySelected: getEntityRef(firstNote[1]) }));
  }

  function handleFloatingWindowTry() {
    if (!project) {
      return;
    }

    const firstNote = Object.entries(project?.notes ?? {})[0];
    if (!firstNote) {
      return;
    }

    dispatch(appendContentWindow({ nodeIdToAppend: firstNote[0] }));
  }

  const handleInfoButtonClick = () => {
    console.log('handleInfoButtonClick');
    setModal({
      customView: getInfoModal({
        onSplitModeTry: handleSplitModeTry,
        onFloatingWindowTry: handleFloatingWindowTry,
      }),
    });
  };

  const projectTitleActions = useMemo(() => {
    return [<SyncButton key="sync-button" />];
  }, []);

  return (
    <UiKitSidebar.Container
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      variant={variant}
      width={mobileWidth}
    >
      <UiKitSidebar.Header>
        <UiKitSidebar.HeaderWrapper>
          <div className={styles['header__logo-wrapper']}>
            <TextatorLogo />
          </div>

          <div className={styles['header__controls']}>
            <Button
              className={styles['header__back']}
              variant="shapeless"
              icon={<AngleLeft16 />}
              onClick={handleBackButtonClick}
            >
              К проектам
            </Button>

            <Button
              className={styles['header__info']}
              variant="shapeless"
              icon={<Info20 />}
              onClick={handleInfoButtonClick}
            />
          </div>
        </UiKitSidebar.HeaderWrapper>
      </UiKitSidebar.Header>

      {project?.root && (
        <UiKitSidebar.Body>
          <UiKitSidebar.TreesContainer>
            {/*<DndProvider backend={MultiBackend} options={HTML5toTouch}>*/}
            <Tree nodeId={project.root} mainTitleActions={projectTitleActions} />
            <Tree nodeId={project.drafts} />
            {/*</DndProvider>*/}
          </UiKitSidebar.TreesContainer>
          <Button
            color="secondary"
            className={styles['close-btn']}
            onClick={toggleSidebar}
            icon={<AlignLess24 color="textator_primary" />}
          />
        </UiKitSidebar.Body>
      )}

      <UiKitSidebar.Footer>
        <AuthContainer variant="standard" />
      </UiKitSidebar.Footer>
    </UiKitSidebar.Container>
  );
}
